// Which way this browser last signed in ("google" | "email"): only the method, never the address,
// and only in this browser. It lets the sign-in page point a returning teacher at the login they
// used before, so a Google tap does not quietly open a second, empty account.
export type LoginMethod = "google" | "email";
const KEY = "classmori-last-login";
const PENDING = "classmori-login-pending";

const read = (storage: () => Storage) => { try { return storage().getItem(KEY); } catch { return null; } };

export function lastLoginMethod(): LoginMethod | null {
  const value = read(() => localStorage);
  return value === "google" || value === "email" ? value : null;
}

export function rememberLastLogin(method: LoginMethod) {
  try { localStorage.setItem(KEY, method); } catch { /* private mode: the hint just stays off */ }
}

/** Google leaves the page, so the sign-in only counts once the app loads signed in again. */
export function markGoogleLoginPending() {
  try { sessionStorage.setItem(PENDING, "google"); } catch { /* ignore */ }
}

export function settleGoogleLogin() {
  try {
    if (sessionStorage.getItem(PENDING) !== "google") return;
    sessionStorage.removeItem(PENDING);
    rememberLastLogin("google");
  } catch { /* ignore */ }
}

const DISMISS_KEY = "classmori-empty-account-hint-dismissed";
export const emptyAccountHintDismissed = () => { try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; } };
export const dismissEmptyAccountHint = () => { try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* ignore */ } };
